<!---------------------------------Web Punching UI with Tabs---------------------------------------------------->

<section class="content-header">
    <div class="row mb-2">
        <div class="col-sm-12">
            <h1 class="page-title">Web Punching</h1>
            <p><strong>Web Punching for Work From Home Employees</strong></p>
        </div>
    </div>
</section>

<!--------------loader-------------------------->
<div *ngIf="loaderShown" class="attendance-loading-container">
    <div class="attendance-custom-loader">
        <div class="attendance-loader-emblem-container">
            <img src="assets/img/logo.png" alt="Company Logo" class="attendance-loader-emblem" />
            <div class="attendance-loading-circle"></div>
        </div>
        <p class="attendance-loading-text">Processing...</p>
    </div>
</div>
<!----------------------------------------------->

<section class="content">
    <div class="container-fluid">
        <!-- Main Tab Group with only 2 tabs -->
<mat-tab-group class="modern-tab-group" animationDuration="0ms" preserveContent>
            <!-- Web Punching Tab -->
            <mat-tab label="Web Punching">
                <div class="row justify-content-center mt-3">
                    <div class="col-md-8 col-lg-6">
                        <!-- Main Punching Card -->
                        <div class="card punch-card">
                            <div class="card-header">
                                <h3 class="card-title">Employee Attendance</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-sm btn-outline-primary"
                                        (click)="resetToToday()" title="Reset to today's date">
                                        <i class="fas fa-calendar-day"></i> Today
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <form>
                                    <!-- Employee Name (Read-only) -->
                                    <div class="form-group">
                                        <label class="form-label">Employee Name</label>
                                        <input type="text" class="form-control" [(ngModel)]="employeeName"
                                            name="employeeName"
                                            [placeholder]="employeeName ? employeeName : 'Loading employee name...'"
                                            readonly>
                                        <small class="form-text text-muted" *ngIf="!employeeName">
                                            <i class="fas fa-exclamation-triangle text-warning"></i>
                                            Employee name not found. Please ensure you are logged in.
                                        </small>
                                    </div>

                                    <!-- Date Selector -->
                                    <div class="form-group">
                                        <label class="form-label">Punch Date <span class="text-danger">*</span></label>
                                        <mat-form-field appearance="fill" class="w-100">
                                            <mat-label>Select Date</mat-label>
                                            <input matInput [matDatepicker]="punchDatePicker" [(ngModel)]="selectedDate"
                                                name="selectedDate" (dateChange)="onDateChange()" [max]="maxDate"
                                                placeholder="Choose date">
                                            <mat-datepicker-toggle matSuffix
                                                [for]="punchDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #punchDatePicker></mat-datepicker>
                                        </mat-form-field>
                                        <!-- <small class="form-text text-muted">
                                            <i class="fas fa-info-circle"></i> You can select any previous date to punch
                                            attendance
                                        </small> -->
                                    </div>

                                    <!-- Check-in Time -->
                                    <div class="form-group">
                                        <label class="form-label">Check-in Time <span
                                                class="text-danger">*</span></label>
                                        <input type="time" class="form-control" [(ngModel)]="checkinTime"
                                            name="checkinTime" [disabled]="checkinSubmitted">
                                    </div>

                                    <!-- Check-in Location -->
                                    <!-- <div class="form-group">
                                        <label class="form-label">Check-in Location <span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" [(ngModel)]="checkinLocation"
                                            name="checkinLocation" placeholder="e.g., Home, Dubai, etc."
                                            [disabled]="checkinSubmitted">
                                    </div> -->

                                    <!-- Submit Check-in Button -->
                                    <div class="form-group" *ngIf="!checkinSubmitted">
                                        <button type="button" class="btn btn-submit btn-block" (click)="submitCheckin()"
    [disabled]="!checkinTime || !employeeId || !employeeName">
                                            <i class="fas fa-sign-in-alt"></i> Submit Check-in
                                        </button>
                                        <small class="form-text text-muted text-center mt-2"
                                            *ngIf="!employeeId || !employeeName">
                                            <i class="fas fa-info-circle"></i>
                                            Please ensure you are logged in to submit attendance
                                        </small>
                                    </div>

                                    <!-- Check-in Success Message -->
                                    <div class="alert alert-success" *ngIf="checkinSubmitted && !checkoutSubmitted">
                                        <i class="fas fa-check-circle"></i> Check-in recorded at {{checkinTime}}.
                                        Please submit check-out when you finish work.
                                    </div>

                                    <!-- Check-out Time (Only shows after check-in submitted) -->
                                    <div class="form-group" *ngIf="checkinSubmitted">
                                        <label class="form-label">Check-out Time <span
                                                class="text-danger">*</span></label>
                                        <input type="time" class="form-control" [(ngModel)]="checkoutTime"
                                            name="checkoutTime" [disabled]="checkoutSubmitted">
                                    </div>

                                    <!-- Check-out Location -->
                                    <!-- <div class="form-group" *ngIf="checkinSubmitted">
                                        <label class="form-label">Check-out Location <span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" [(ngModel)]="checkoutLocation"
                                            name="checkoutLocation" placeholder="e.g., Home, Dubai, etc."
                                            [disabled]="checkoutSubmitted">
                                    </div> -->

                                    <!-- Submit Check-out Button -->
                                    <div class="form-group" *ngIf="checkinSubmitted && !checkoutSubmitted">
                                        <button type="button" class="btn btn-submit btn-block" (click)="submitCheckout()" 
    [disabled]="!checkoutTime">
                                            <i class="fas fa-sign-out-alt"></i> Submit Check-out
                                        </button>
                                    </div>

                                    <!-- Final Success Message -->
                                    <div class="alert alert-success" *ngIf="checkoutSubmitted">
                                        <i class="fas fa-check-circle"></i> Attendance recorded successfully!
                                        <br>
                                        <small>Check-in: {{checkinTime}} | Check-out: {{checkoutTime}}</small>
                                    </div>

                                    <!-- Info Box -->
                                    <!-- <div class="alert alert-info mt-3" *ngIf="!checkinSubmitted">
                                        <h6><i class="fas fa-info-circle"></i> Important Notes:</h6>
                                        <ul class="mb-0 pl-3">
                                            <li>You can punch attendance for any date (current or previous)</li>
                                            <li>Once check-in is submitted, it cannot be edited</li>
                                            <li>Check-out can only be done after check-in</li>
                                            <li>Location is mandatory for both check-in and check-out</li>
                                        </ul>
                                    </div> -->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <!-- Attendance History Tab -->
            <mat-tab label="Attendance History">
                <div class="card user-type-card mt-3">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col-md-6">
                                <div class="header-title">
                                    <h2 class="mb-0">
                                        <i class="fas fa-history me-2"></i>
                                        Attendance History
                                    </h2>
                                </div>
                            </div>
                            <div class="col-md-6 d-flex justify-content-end">
                                <!-- <button type="button" class="btn btn-success submit-btn" (click)="refreshHistory()">
                                    <i class="fas fa-sync-alt me-2"></i>Refresh
                                </button> -->
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <!-- Material Date Range Picker -->
                        <div class="row mb-3 align-items-end">
                            <div class="col-md-4">
                                <label class="form-label">Date Range</label>
                                <div class="date-range-field">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Enter a date range</mat-label>
                                        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                                            <input matStartDate formControlName="start" placeholder="Start date">
                                            <input matEndDate formControlName="end" placeholder="End date">
                                        </mat-date-range-input>
                                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker></mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <button type="button" class="btn btn-primary compact-btn-apply"
                                    (click)="filterHistory()">
                                    Apply
                                </button>
                            </div>
                            <div class="col-md-3">
    <label class="form-label">Status</label>
    <select class="form-control compact-select" [(ngModel)]="selectedStatus" (change)="filterByStatus()">
        <option value="">All Status</option>
        <option value="present">Present</option>
        <option value="absent">Absent</option>
        <!-- <option value="late">Late</option>
        <option value="half day">Half Day</option> -->
        <option value="holiday">Holiday</option>
    </select>
</div>
                            <div class="col-md-3">
                                <!-- Space for future buttons -->
                            </div>
                        </div>

                        <!-- Attendance History Table -->
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead class="table-light">
                                    <tr>
                                        <th>Date</th>
                                        <th>Check-in Time</th>
                                        <th>Check-out Time</th>
                                        <!-- <th>Check-in Location</th>
                                        <th>Check-out Location</th> -->
                                        <th>Status</th>
                                        <!-- <th>Late In</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- In your HTML template, update this section: -->
                                    <tr *ngFor="let record of filteredAttendanceList">
                                        <td>{{record.date_formated || (record.date | date:'dd/MM/yyyy')}}</td>
                                        <td>{{extractTimeValue(record.work_in)}}</td>
                                        <td>{{extractTimeValue(record.work_out)}}</td>
                                        <!-- <td>{{record.checkin_location || '-'}}</td>
                                        <td>{{record.checkout_location || '-'}}</td> -->
                                        <td>
                                            <span class="badge" [ngClass]="getStatusBadgeClass(record)">
                                                {{getDisplayStatus(record)}}
                                            </span>
                                        </td>
                                        <!-- <td>
                                            <span *ngIf="record.is_late_checkin" class="badge bg-warning">
                                                <i class="fas fa-clock"></i> Late
                                            </span>
                                            <span *ngIf="!record.is_late_checkin" class="text-muted">-</span>
                                        </td> -->
                                    </tr>
                                    <tr *ngIf="filteredAttendanceList.length === 0">
                                        <td colspan="7" class="text-center py-4">
                                            <div class="empty-state">
                                                <i class="fas fa-calendar-times fa-2x text-muted mb-2"></i>
                                                <p class="text-muted mb-0">No attendance records found</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Summary Card -->
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <div class="card summary-card">
                                    <div class="card-header">
                                        <h5 class="card-title mb-0">
                                            <i class="fas fa-chart-bar me-2"></i>Attendance Summary
                                        </h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="summary-item">
                                                    <h6>Total Days</h6>
                                                    <h3>{{summary.totalDays}}</h3>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="summary-item">
                                                    <h6>Present</h6>
                                                    <h3 class="text-success">{{summary.present}}</h3>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="summary-item">
                                                    <h6>Absent</h6>
                                                    <h3 class="text-danger">{{summary.absent}}</h3>
                                                </div>
                                            </div>
                                            <!-- <div class="col-md-3">
                                                <div class="summary-item">
                                                    <h6>Late</h6>
                                                    <h3 class="text-warning">{{summary.late}}</h3>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</section>